<template>
    <div class="error-page">
      <div class="content">
        <h1>Something Went Wrong</h1>
        <p>We're sorry, an error occurred while loading the page.</p>
        <p><strong>{{ errorMessage || 'Please try again later or contact the administrator.' }}</strong></p>
        <button @click="refreshPage">Retry</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      errorMessage: {
        type: String,
        default: ''
      }
    },
    methods: {
      refreshPage() {
        window.location.reload();
      }
    }
  }
  </script>
  
  <style scoped>
  .error-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    text-align: center;
  }
  .content {
    padding: 30px;
    background: #fff;
    border: 1px solid #f5c6cb;
    border-radius: 10px;
    box-shadow: 0 0 8px rgba(0,0,0,0.05);
  }
  button {
    margin-top: 20px;
    background: #e74c3c;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
  }
  button:hover {
    background: #ff6f61;
  }
  </style>
  